import React from "react";
import PropTypes from "prop-types";
import { FiEye } from "@react-icons/all-files/fi/FiEye";
import { FiEyeOff } from "@react-icons/all-files/fi/FiEyeOff";
import styles from "./preview.module.scss";

const PreviewLink = ({ page, preview, activeMarket }) => {

  let path = activeMarket && activeMarket.path_prefix ? page.path.replace(`${activeMarket.path_prefix}/`, '') : page.path;
  path =  activeMarket && page.path === `${activeMarket.path_prefix}` ? activeMarket.path_prefix : path;

  return (
    <li>
      <a
        className={`${styles.preview} ${preview ? styles.active : ""}`}
        target={!preview ? "_blank" : ""}
        href={
          !preview
            ? `/preview/?path=${path}&page_id=${page.id}`
            : `/${page.path}`
        }
        rel="noreferrer"
      >
        Preview Page {preview ? <FiEyeOff /> : <FiEye />}
      </a>
    </li>
  )  
};

PreviewLink.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.number,
    path: PropTypes.string,
    market_id: PropTypes.number,
    market: PropTypes.string,
  }),
  activeMarket: PropTypes.shape({
    path_prefix: PropTypes.string,
  }),
  preview: PropTypes.bool,
};

export default PreviewLink;
